module.exports = __webpack_public_path__ + "img/yhbg@2x (1).aa22ca09.png";